import cn from "classnames";
import Loader from "components/shared/loader";
import { getInitialStateFromConfig, serializeReq, validateForm } from "helpers/form";
import { formatNumber } from "helpers/system";
import { requiredField } from "helpers/validators";
import Tooltip from "rc-tooltip";
import React from "react";
import { applyExcessMileage, getExcessMileage } from "sources/books/bids";
import { FormTemplate } from "./templates";

const inputProps = {
    labelWrapper: "col-form-label col-form-label-sm col-12 text-muted",
    fieldWrapper: "col-12",
    bWrapper: "row mb-2",
};

const config = {
    bidId: {},
    excessMileages: {
        value: [],
        config: {
            id: {},
            values: {
                config: {
                    excessMileage: {
                        validators: [requiredField],
                        required: true,
                        label: "Перепробег (в км.)",
                        inputProps: { name: "excessMileage", type: "number" },
                        ...inputProps,
                    },
                    isApproved: {
                        label: "Согласована логистом",
                        inputProps: { name: "isApproved" },
                        type: "checkbox",
                        fieldBeforeLabel: true,
                        labelWrapper: "col-auto col-form-label col-form-label-sm pl-0",
                        fieldWrapper: "col-auto pr-1",
                        bWrapper: "d-flex ml-1 align-items-center",
                    },
                    reasonTypeId: {
                        label: "Тип причины перепробега",
                        inputProps: { name: "reasonTypeId" },
                        dictionary: "excessMileageReasonType",
                        required: true,
                        menuPortalTarget: document.body,
                        ...inputProps,
                    },
                    reason: {
                        label: "Причина (максимум 256 символов)",
                        inputProps: { name: "reason" },
                        textarea: true,
                        ...inputProps,
                    },
                },
            },
        },
    },
};

const initialState = getInitialStateFromConfig(config);

class ExcessMileageModal extends FormTemplate {
    componentDidMount() {
        this.estimatedMileages = {};
        const initial = this.props.initialState ? this.props.initialState : {};
        this.setState({ isValid: true, ...initial });
        getExcessMileage(this.props.bidId).then((excessMileages) => {
            this.setState({ isLoading: false, ...excessMileages });
        });
    }

    isValidForm = (state) => {
        const { config } = this.props;
        const serialized = serializeReq(state);
        return serialized.excessMileages.every((item) => validateForm(config.excessMileages.config, item));
    };

    renderActionSend = () => {
        const cname = "btn btn-brand btn-sm modal-window__footer-action";
        return <input type="submit" className={cname} value="Сохранить" />;
    };

    sendRequest = (stateData) =>
        applyExcessMileage({
            bidId: Number(this.props.bidId),
            excessMileages: stateData.excessMileages
                .filter((item) => item.values.length > 0)
                .map(({ id, values }) => ({ id, values })),
        });

    estimatedMileage = (item) => {
        if (this.estimatedMileages[item.id] !== undefined) {
            return this.estimatedMileages[item.id];
        }
        const mileage = item.factMileage - item.planMileage;
        this.estimatedMileages[item.id] = mileage > 0 ? mileage : 0;
        return this.estimatedMileages[item.id];
    };

    addReason = (itemIndex) => {
        const excessMileages = [...this.state.excessMileages];
        excessMileages[itemIndex].values.push({});
        this.setState({ excessMileages });
    };

    removeReason = (itemIndex, reasonIndex) => {
        const excessMileages = [...this.state.excessMileages];
        this.state.excessMileages[itemIndex].values.splice(reasonIndex, 1);
        this.setState({ excessMileages });
    };

    renderBody = () => {
        if (this.state.isLoading) {
            return (
                <div className="loader-wrap">
                    <Loader prefix="margin-center" />
                </div>
            );
        }
        const cname = cn("modal-window__form", { "modal-window__form--invalid": !this.state.isValid });
        return (
            <form className={cname} onSubmit={this.handleSubmit}>
                {this.renderBodyInner()}
                {this.renderFormActions()}
            </form>
        );
    };

    setValue = ({ name, value }, itemIndex, reasonIndex) => {
        const excessMileages = [...this.state.excessMileages];
        excessMileages[itemIndex].values[reasonIndex][name] = value;
        const isValid = this.isValidForm({ ...this.state, excessMileages });
        this.setState({ excessMileages, ...(isValid ? { isValid: true } : {}) });
    };

    renderBodyInner = () => {
        const { excessMileage, reason, reasonTypeId, isApproved } =
            this.props.config.excessMileages.config.values.config;
        const { activeKms, planKms, criticalMileage } = this.props;
        const showActions = this.state.message
            ? activeKms - planKms >= criticalMileage
            : this.state.excessMileages.some((item) => item.factMileage - item.planMileage >= criticalMileage);
        return (
            <>
                {this.state.message && (
                    <>
                        <div className="alert alert-warning">{this.state.message}</div>
                        <div className="d-flex justify-content-center">
                            <div className="d-inline-block b-mileage__card mb-4">
                                <div className="d-inline-block text-center px-5">
                                    <strong>{formatNumber(planKms)} км.</strong>
                                    <div>
                                        <small className="text-muted">Плановый пробег по заявке</small>
                                    </div>
                                </div>
                                <div className="d-inline-block text-center pr-5">
                                    <strong>{formatNumber(activeKms)} км.</strong>
                                    <div>
                                        <small className="text-muted">Фактический пробег по заявке</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
                {this.state.excessMileages.map((item, index) => (
                    <div key={item.id} className="pb-3">
                        <div className="form-group">
                            <h5 className="pb-2">
                                <span className="text-muted">Смена {index + 1}.</span> {item.driver.fullName}
                            </h5>
                            <div className="d-flex pb-2">
                                <div className="b-mileage__card d-flex justify-content-between w-100">
                                    {!this.state.message && (
                                        <div className="text-center">
                                            <strong>{formatNumber(item.planMileage)} км.</strong>
                                            <div>
                                                <small className="text-muted">Плановый пробег</small>
                                            </div>
                                        </div>
                                    )}
                                    <div className="text-center">
                                        <strong>{formatNumber(item.factMileage)} км.</strong>
                                        <div>
                                            <small className="text-muted">Фактический пробег</small>
                                        </div>
                                    </div>
                                    {!this.state.message && (
                                        <div className="text-center">
                                            <strong
                                                className={this.estimatedMileage(item) ? "text-danger" : "text-success"}
                                            >
                                                {formatNumber(this.estimatedMileage(item))} км.
                                            </strong>
                                            <div>
                                                <small className="text-muted">Расчетный перепробег</small>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        {showActions && (
                            <>
                                {item.values?.map((reasonItem, i) => (
                                    <div key={i} className="pb-3">
                                        <div className="d-flex align-items-center">
                                            <div className="font-weight-bold">
                                                <Tooltip overlay="Удалить" placement="bottom">
                                                    <span
                                                        className="text-danger cursor-pointer p-1 mr-1"
                                                        onClick={this.removeReason.bind(this, index, i)}
                                                    >
                                                        &times;
                                                    </span>
                                                </Tooltip>
                                                Причина {i + 1}
                                            </div>
                                            {this.renderCheckbox({
                                                ...isApproved,
                                                onChange: (...args) => this.setValue(...args, index, i),
                                                value: reasonItem.isApproved,
                                            })}
                                        </div>
                                        {this.renderField({
                                            ...excessMileage,
                                            onChange: (...args) => this.setValue(...args, index, i),
                                            value: reasonItem.excessMileage,
                                        })}
                                        {this.renderSelect({
                                            ...reasonTypeId,
                                            onChange: (...args) => this.setValue(...args, index, i),
                                            value: reasonItem.reasonTypeId,
                                        })}
                                        {this.renderField({
                                            ...reason,
                                            onChange: (...args) => this.setValue(...args, index, i),
                                            value: reasonItem.reason,
                                        })}
                                    </div>
                                ))}
                                <div className="inline-btn inline-btn--plus" onClick={this.addReason.bind(this, index)}>
                                    Добавить причину перепробега
                                </div>
                            </>
                        )}
                    </div>
                ))}
            </>
        );
    };
}

const ConfiguredModal = (props) => <ExcessMileageModal {...props} config={config} initialState={initialState} />;

export default ConfiguredModal;
